import { Component, ElementRef, Renderer2, viewChild, inject } from '@angular/core';
import { scrollToTop, WindowService } from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-back-to-top',
    templateUrl: './back-to-top.component.html',
    standalone: false,
    host: {
        '(window:scroll)': 'onScroll()',
    },
})
export class BackToTopComponent {
    private renderer = inject(Renderer2);
    private windowService = inject(WindowService);

    readonly backToTop = viewChild<ElementRef>('backToTop');

    scrollTop($event: MouseEvent) {
        $event.preventDefault();
        scrollToTop(400);
    }

    onScroll() {
        const offset = 200;
        const currentPosition = this.windowService.pageYOffset;

        const backToTop = this.backToTop();
        if (backToTop) {
            if (currentPosition > offset) {
                if (!backToTop.nativeElement.classList.contains('is-active')) {
                    this.renderer.addClass(backToTop.nativeElement, 'is-active');
                }
            } else {
                this.renderer.removeClass(backToTop.nativeElement, 'is-active');
            }
        }
    }
}
